// src/services/apiService.js

export const generateModel = async (description) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  try {
    // Send the request to the backend
    const response = await fetch(`${API_BASE_URL}/api/generate-model`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ description }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to generate model');
    }

    return data; // { code, stepFiles, gltfFiles }
  } catch (error) {
    console.error('Error in generateModel:', error);
    throw error;
  }
};

// src/services/apiService.js

export const generateIterativeModel = async (description) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  try {
    // Send the request to the backend
    const response = await fetch(`${API_BASE_URL}/api/iterative-design`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ description }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to generate model');
    }

    return data; // { code, stepFiles, gltfFiles }
  } catch (error) {
    console.error('Error in generateModel:', error);
    throw error;
  }
};

